export default "__VITE_ASSET__T5aIoi$T__"